import { FastField, getIn, useFormikContext } from "formik";
import AppComposerField from "./AppComposerField";
import React, { useEffect, useRef } from "react";
import { theme } from "../../../Customization/Theme";
import {
  StyledWidgetInputBox,
} from "../../Styles/StyledForms";
import { useAppSelector } from "../../../Store";

import { allMessagesStore } from "../../../Store/Slices/socket/AllMessagesSlice";
import AppErrorMessage from "./AppErrorMessage";
import AppSendSubmitButton from "./AppSendSubmitButton";
import AppVoiceButton from "./AppVoiceButton";

interface Props {
  name?: string;
  label?: string;
  children?: React.ReactNode;
  showVoiceButton?: boolean;
  isTextToSpeechEnabled?: boolean;
  [otherProps: string]: any;
  ref?: any;
}

const AppFlowTextField: React.FC<Props> = ({
  name = "textField",
  label = "Enter your text",
  children,
  showVoiceButton = false,
  isTextToSpeechEnabled = false,
  ...otherProps
}) => {
  const { errors, touched, values, handleChange, setFieldValue, handleSubmit } = useFormikContext<any>();
  const { typingStatus } = useAppSelector(allMessagesStore);

  const handleVoiceInput = (text: string) => {
    setFieldValue(name, text);
    // Automatically submit the form after voice input
    setTimeout(() => {
      handleSubmit();
    }, 100);
  };

  return (
    <StyledWidgetInputBox
      disabled={typingStatus ? true : false}
      error={getIn(errors, name) && getIn(touched, name) }
    >
      <FastField name={name}>
        {({ field }: any) => (
          <AppComposerField
            {...otherProps}
            {...field}
            value={getIn(values, name) || ""}
            onChange={(e: any) => {
              handleChange(e);
            }}
            autoFocus={true}
            placeholder={label}
          />
        )}
      </FastField>
      {showVoiceButton ? (
          getIn(values, name)?.length > 0 ? (
            <AppSendSubmitButton />
          ) : (
            <AppVoiceButton onVoiceInput={handleVoiceInput} />
          )
        ) : (
          <AppSendSubmitButton />
        )}

      <AppErrorMessage
        error={getIn(errors, name)}
        visible={getIn(touched, name) }
      />
    </StyledWidgetInputBox>
  );
};

export default AppFlowTextField;
